module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-sign-up-guide-f779cdc157cd241074616f0a802cdafa.jpg";